import {
  DollarSign,
  FileBox,
  History,
  LayoutDashboard,
  MessageSquare,
  Scissors,
  Settings,
  Users,
} from 'lucide-react';

export const menu = [
  {
    id: 1,
    title: 'Main Menu',
    listItems: [
      {
        id: 1,
        title: 'Dashboard',
        url: '/dashboard',
        icon: LayoutDashboard,
      },
      {
        id: 2,
        title: 'Chat',
        url: '/chat',
        icon: MessageSquare,
      },
      // {
      //   id: 3,
      //   title: 'Notifications',
      //   url: '/#',
      //   icon: Bell,
      // },
    ],
  },
  {
    id: 2,
    title: 'Management',
    listItems: [
      {
        id: 1,
        title: 'History Records',
        url: '/history',
        icon: History,
      },
      {
        id: 2,
        title: 'Payroll',
        url: '/payroll',
        icon: DollarSign,
      },
      {
        id: 3,
        title: 'Employees',
        url: '/employees',
        icon: Users,
      },
      {
        id: 4,
        title: 'Services',
        url: '/services',
        icon: Scissors,
      },
      {
        id: 5,
        title: 'File Manager',
        url: '/filemanager',
        icon: FileBox,
      },
    ],
  },
  {
    id: 3,
    title: 'Settings',
    listItems: [
      {
        id: 1,
        title: 'Setting',
        url: '/setting',
        icon: Settings,
      },
    ],
  },
];
